import axios from "axios";

// export const API_BASE_URL = process.env.REACT_APP_API_BASE || "";
export const API_BASE_URL = "https://e-gramota.com.ua"; // Replace with your actual API base URL

export function buildApiFileUrl(path) {
    const normalizedPath = String(path || "").startsWith("/")
        ? String(path || "")
        : `/${path || ""}`;

    return `${API_BASE_URL}${normalizedPath}`;
}

const http = axios.create({
    baseURL: API_BASE_URL,
    headers: {
        "Content-Type": "application/json",
    },
    withCredentials: true,
});

export default http;
